import type { Etapes, ReglagesPaquet } from './reglages';

/** Une durée saisie dans les étapes, plus longue que la fenêtre de débordement. */
export interface DureeHorsFenetre {
  etapes: 'apprentissage' | 'reapprentissage';
  /** 1 (À revoir), 2 (Difficile) ou 3 (Bien). */
  note: 1 | 2 | 3;
  /** Numéro du passage (à partir de 1) ; `null` pour À revoir, saisi une fois par liste. */
  passage: number | null;
  minutes: number;
}

function dureesHorsFenetre(
  nom: DureeHorsFenetre['etapes'],
  etapes: Etapes,
  fenetre: number,
): DureeHorsFenetre[] {
  const resultat: DureeHorsFenetre[] = [];
  if (etapes.aRevoir !== null && etapes.aRevoir > fenetre) {
    resultat.push({ etapes: nom, note: 1, passage: null, minutes: etapes.aRevoir });
  }
  etapes.passages.forEach((passage, i) => {
    if (passage.difficile > fenetre) {
      resultat.push({ etapes: nom, note: 2, passage: i + 1, minutes: passage.difficile });
    }
    if (passage.bien !== undefined && passage.bien > fenetre) {
      resultat.push({ etapes: nom, note: 3, passage: i + 1, minutes: passage.bien });
    }
  });
  return resultat;
}

/**
 * Durées des étapes plus longues que la fenêtre de débordement (spécification §3,
 * « Avertissement »). Liste vide : pas d'avertissement. Sinon le champ s'affiche en rouge :
 * les cartes notées avec ces boutons ne reviendront pas dans la séance.
 */
export function avertissementFenetreDebordement(
  reglages: Pick<
    ReglagesPaquet,
    'fenetreDebordementMinutes' | 'etapesApprentissage' | 'etapesReapprentissage'
  >,
): DureeHorsFenetre[] {
  const fenetre = reglages.fenetreDebordementMinutes;
  return [
    ...dureesHorsFenetre('apprentissage', reglages.etapesApprentissage, fenetre),
    ...dureesHorsFenetre('reapprentissage', reglages.etapesReapprentissage, fenetre),
  ];
}
